module.exports = __webpack_public_path__ + "img/official_galaxy.cb6102e6.png";